export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const PUT_EMAIL = "PUT_EMAIL";
export const PUT_PASSWORD = "PUT_PASSWORD";
export const PUT_CODIGODISPOSITIVO = "PUT_CODIGODISPOSITIVO";